export const BankRoute = {
  index: "/",
  tasks: `/tasks`,
  stake: `/stake`,
  buy: `/buy`,
  history: `/stake/history`,
  referrals: `/referrals`,
} as const;
